import roles from "./roles";
const defaultRoutes = {
    [roles.SUPER_ADMIN]: "/admin",
    [roles.USER]: "/user/main",
    [roles.ADMIN]: "/management",
    [roles.TRAINER]: "/admin",
    [roles.TRAINER_ADMIN]: "/admin/dashboard",
    [roles.VIDEO_MANAGER]: "/admin/dashboard"
};
export default {
    ...defaultRoutes,
    getDefaultLandingPage(role = null) {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));        
        role = role || (userInfo && userInfo.role) || roles.USER;
        return defaultRoutes[role];
    }
}